export default __webpack_public_path__ + "static/media/main2.ce7ab1d3.png";